module.exports = __webpack_public_path__ + "img/share_txt_kh.f9e5bdc4.png";